import React, { useState } from 'react';
import SelectorVariantesModal from '../Generales/SelectorVariantes';

function CatalogoLista({ productos, onAddItem, onRemoveItem, carro = [], obtenerUrlImagen, esSoloLectura = false, tarjetaRadio = 'redondeado', tarjetaSombra = false, colorPrimario = '#F26B21', mostrarPrecios = true }) {
    const cardRadii = { cuadrado: '6px', redondeado: '16px', extra: '28px' };
    const cardRadius = cardRadii[tarjetaRadio] || '16px';
    const cardShadow = tarjetaSombra ? '0 4px 12px rgba(0,0,0,0.12)' : '0 1px 3px rgba(0,0,0,0.04)';
    const [productoParaVariantes, setProductoParaVariantes] = useState(null);
    const [productoParaDetalle, setProductoParaDetalle] = useState(null);

    const getCantidadSimple = (id) => {
        const item = carro.find(i => i.id === id);
        return item ? item.cantidad : 0;
    };

    const handleAddClick = (e, producto) => {
        e.stopPropagation();
        if (producto.grupos && producto.grupos.length > 0) {
            setProductoParaVariantes(producto);
        } else {
            onAddItem({ ...producto, precio: Number(producto.valor || 0) });
        }
    };

    return (
        <div className="grid-productos-container">
            <style>{`
                /* ============================================
                   🎨 ESTILO GOMENU - CATÁLOGO PREMIUM
                   ============================================ */
                
                /* GRILLA PRINCIPAL: 2 columnas en mobile, 4 en desktop */
                .grid-productos-container {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 12px;
                    padding: 8px;
                }

                @media (min-width: 992px) {
                    .grid-productos-container {
                        grid-template-columns: repeat(4, 1fr);
                        gap: 20px;
                        padding: 16px;
                    }
                }

                /* CARD: Sin bordes, solo sombra sutil */
                .producto-card {
                    background: #fff;
                    border-radius: ${cardRadius};
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                    position: relative;
                    transition: transform 0.2s ease, box-shadow 0.2s ease;
                    box-shadow: ${cardShadow};
                }

                .producto-card:hover {
                    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
                }

                .producto-card:active {
                    transform: scale(0.97);
                }

                /* IMAGEN: Cuadrada, sin bordes, ocupa todo el ancho */
                .imagen-container {
                    width: 100%;
                    aspect-ratio: 1 / 1;
                    overflow: hidden;
                    background: #f4f4f4;
                    position: relative;
                }

                .imagen-container img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    display: block;
                }

                /* BADGE PRECIO: Estilo GoMenu - verde semitransparente sobre la imagen */
                .precio-badge {
                    position: absolute;
                    bottom: 8px;
                    left: 8px;
                    z-index: 5;
                    background: rgba(0, 0, 0, 0.65);
                    backdrop-filter: blur(4px);
                    color: #fff;
                    font-size: 0.85rem;
                    font-weight: 800;
                    padding: 4px 10px;
                    border-radius: 8px;
                    letter-spacing: -0.01em;
                    line-height: 1.2;
                }

                /* BOTÓN FLOTANTE "+" - Círculo blanco con sombra */
                .btn-add-fast {
                    position: absolute;
                    top: 8px;
                    right: 8px;
                    z-index: 10;
                    background: white;
                    color: #111;
                    border-radius: 50px;
                    min-width: 32px;
                    height: 32px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 800;
                    font-size: 1.1rem;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.12);
                    cursor: pointer;
                    border: none;
                    padding: 0 8px;
                    font-family: sans-serif;
                    transition: all 0.15s ease;
                }

                .btn-add-fast:active {
                    transform: scale(0.9);
                }

                .contador-pill {
                    background: #111;
                    color: #fff;
                    font-size: 0.8rem;
                    padding: 0 6px;
                    gap: 6px;
                    min-width: 60px;
                }

                .contador-pill span {
                    cursor: pointer;
                    user-select: none;
                }

                /* INFO DEL PRODUCTO - Minimalista */
                .info-producto {
                    padding: 10px 10px 12px;
                    display: flex;
                    flex-direction: column;
                    flex-grow: 1;
                }

                .nombre-prod {
                    font-size: 0.8rem !important;
                    font-weight: 700;
                    color: #1a1a1a;
                    line-height: 1.15;
                    letter-spacing: -0.01em;
                    margin-bottom: 2px;
                    text-transform: capitalize;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    min-height: 1.15em;
                }

                /* Descripción visible con estilo sutil */
                .desc-prod {
                    font-size: 0.65rem !important;
                    color: #888;
                    line-height: 1.3;
                    margin-top: 2px;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                /* MODO SOLO LECTURA: Ocultar botones */
                .modo-lectura .btn-add-fast {
                    display: none !important;
                }

                /* MODAL DETALLE DE PRODUCTO */
                .detalle-overlay {
                    position: fixed;
                    inset: 0;
                    background: rgba(0,0,0,0.6);
                    z-index: 1050;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 16px;
                }

                .detalle-modal {
                    background: #fff;
                    border-radius: 16px;
                    overflow: hidden;
                    max-width: 360px;
                    width: 100%;
                    max-height: 90vh;
                    display: flex;
                    flex-direction: column;
                    position: relative;
                }

                .detalle-imagen {
                    width: 100%;
                    aspect-ratio: 1 / 1;
                    background: #f4f4f4;
                    overflow: hidden;
                }

                .detalle-imagen img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    display: block;
                }

                .detalle-wrapper {
                    position: relative;
                    max-width: 360px;
                    width: 100%;
                }

                .detalle-cerrar {
                    position: absolute;
                    top: -14px;
                    right: -14px;
                    z-index: 1100;
                    background: #fff;
                    color: #1a1a1a;
                    border: none;
                    border-radius: 50%;
                    width: 36px;
                    height: 36px;
                    font-size: 1rem;
                    font-weight: 700;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 2px 10px rgba(0,0,0,0.35);
                    line-height: 1;
                }

                .detalle-info {
                    padding: 16px;
                    overflow-y: auto;
                }

                .detalle-nombre {
                    font-size: 1.1rem;
                    font-weight: 800;
                    color: #1a1a1a;
                    text-transform: capitalize;
                    margin-bottom: 6px;
                }

                .detalle-descripcion {
                    font-size: 0.85rem;
                    color: #666;
                    line-height: 1.4;
                    margin-bottom: 12px;
                }

                .detalle-precio {
                    font-size: 1.3rem;
                    font-weight: 800;
                    color: #111;
                }

                .btn-agregar-detalle {
                    width: 100%;
                    margin-top: 14px;
                    padding: 12px;
                    border: none;
                    border-radius: ${cardRadius};
                    background: ${colorPrimario};
                    color: #fff;
                    font-weight: 700;
                    font-size: 0.9rem;
                    cursor: pointer;
                }

                .btn-agregar-detalle:active {
                    transform: scale(0.98);
                }
            `}</style>

            {productos && productos.map((producto) => {
                const tieneVariantes = producto.grupos && producto.grupos.length > 0;
                const cantidad = tieneVariantes ? 0 : getCantidadSimple(producto.id);
                const precioTexto = Number(producto.valor || producto.precio || 0).toLocaleString('es-CL');

                // La tarjeta abre el detalle; agregar es solo con el boton +.
                // Antes cualquier toque en la tarjeta sumaba el producto, asi que
                // el que tocaba para leer la descripcion se lo llevaba sin querer.
                return (
                    <div key={producto.id} className="producto-card" onClick={() => setProductoParaDetalle(producto)} style={{ cursor: 'pointer' }}>
                        {/* CONTENEDOR IMAGEN + BADGE + BOTÓN */}
                        <div className="imagen-container" onClick={(e) => { e.stopPropagation(); setProductoParaDetalle(producto); }}>
                            <img
                                src={obtenerUrlImagen(producto)}
                                alt={producto.nombre}
                                onError={(e) => { e.target.src = 'https://via.placeholder.com/300?text=Comida'; }}
                                loading="lazy"
                            />
                            
                            {/* BADGE PRECIO ESTILO GOMENU (sobre la imagen) */}
                            {mostrarPrecios && <div className="precio-badge">${precioTexto}</div>}

                            {/* BOTÓN DINÁMICO + / CONTADOR */}
                            {!esSoloLectura && !tieneVariantes && cantidad > 0 ? (
                                <div className="btn-add-fast contador-pill">
                                    <span onClick={(e) => { e.stopPropagation(); onRemoveItem(producto.id); }}>－</span>
                                    <span>{cantidad}</span>
                                    <span onClick={(e) => { e.stopPropagation(); handleAddClick(e, producto); }}>＋</span>
                                </div>
                            ) : !esSoloLectura && (
                                <div className="btn-add-fast" onClick={(e) => { e.stopPropagation(); handleAddClick(e, producto); }}>
                                    ＋
                                </div>
                            )}

                            {/* INDICADOR DE VARIANTES si las tiene */}
                            {tieneVariantes && !esSoloLectura && (
                                <div style={{
                                    position: 'absolute',
                                    bottom: '8px',
                                    right: '8px',
                                    background: 'rgba(255,255,255,0.9)',
                                    borderRadius: '6px',
                                    padding: '2px 6px',
                                    fontSize: '0.6rem',
                                    fontWeight: 600,
                                    color: '#666',
                                    zIndex: 5
                                }}>
                                    + opciones
                                </div>
                            )}
                        </div>

                        {/* Nombre + Descripción */}
                        <div className="info-producto">
                            <div className="nombre-prod">{producto.nombre.toLowerCase()}</div>
                            {producto.descripcion && (
                                <div className="desc-prod">{producto.descripcion}</div>
                            )}
                        </div>
                    </div>
                );
            })}

            {productoParaVariantes && (
                <SelectorVariantesModal
                    item={productoParaVariantes}
                    onClose={() => setProductoParaVariantes(null)}
                    onConfirm={(itemFinal) => {
                        onAddItem(itemFinal);
                        setProductoParaVariantes(null);
                    }}
                />
            )}

            {productoParaDetalle && (
                <div className="detalle-overlay" onClick={() => setProductoParaDetalle(null)}>
                    <div className="detalle-wrapper" onClick={(e) => e.stopPropagation()}>
                        <button className="detalle-cerrar" onClick={() => setProductoParaDetalle(null)}>✕</button>
                        <div className="detalle-modal">
                        <div className="detalle-imagen">
                            <img
                                src={obtenerUrlImagen(productoParaDetalle)}
                                alt={productoParaDetalle.nombre}
                                onError={(e) => { e.target.src = 'https://via.placeholder.com/300?text=Comida'; }}
                            />
                        </div>
                        <div className="detalle-info">
                            <div className="detalle-nombre">{productoParaDetalle.nombre.toLowerCase()}</div>
                            {productoParaDetalle.descripcion && (
                                <div className="detalle-descripcion">{productoParaDetalle.descripcion}</div>
                            )}
                            <div className="detalle-precio">
                                ${Number(productoParaDetalle.valor || productoParaDetalle.precio || 0).toLocaleString('es-CL')}
                            </div>
                            {!esSoloLectura && (
                                <button
                                    className="btn-agregar-detalle"
                                    onClick={() => {
                                        const producto = productoParaDetalle;
                                        setProductoParaDetalle(null);
                                        if (producto.grupos && producto.grupos.length > 0) {
                                            setProductoParaVariantes(producto);
                                        } else {
                                            onAddItem({ ...producto, precio: Number(producto.valor || producto.precio || 0) });
                                        }
                                    }}
                                >
                                    Agregar al pedido
                                </button>
                            )}
                        </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default CatalogoLista;